export default __webpack_public_path__ + "static/media/connect-api-gui.0c115f23.svg";